import React, { useState } from 'react';
import { PlusCircle } from 'lucide-react';
import { InfoBox, InputGroup, fmtCur } from '../Common';

const CompTool = () => {
    const [cap, setCap] = useState(1000000);
    const [ret, setRet] = useState(25);
    const [prd, setPrd] = useState(10);

    let final = cap;
    for (let i = 0; i < prd; i++) {
        final *= (1 + (ret / 100));
    }

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Compounding Simulator</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Capital" value={cap} onChange={setCap} />
                <InputGroup label="Annual Return %" value={ret} onChange={setRet} />
                <InputGroup label="Years" value={prd} onChange={setPrd} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-purple">
                    <div className="tct-data-row"><span className="tct-label">Future Capital</span><span className="tct-value big-value val-purple">{fmtCur.format(final)}</span></div>
                </div>
            </div>
            <InfoBox
                title="The Power of Compounding in Trading"
                meta="Compounding allows traders to grow capital exponentially over time"
                sections={[
                { title: "Introduction", content: "Compounding occurs when profits are reinvested." },
                { title: "Example", content: "Capital = ₹10L<br>Annual return = 25%<br><br>After 10 years:<br>Capital becomes approximately ₹93L." },
                { title: "Why It Matters", content: "Small consistent returns can produce enormous long term growth." }
                ]}
            />
        </div>
    );
};

export default CompTool;
